function openCity(evt, cityName, sectionName) {
  // Declare all variables
  var i, tabcontent, tablinks;

  // Get the section element
  var section = document.getElementById("shopify-section-" + sectionName);

  // Get all elements with class="tabcontent" inside the specified section and hide them
  tabcontent = section.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Get all elements with class="tablinks" inside the specified section and remove the class "active"
  tablinks = section.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Show the current tab, and add an "active" class to the button that opened the tab
  var currentTab = section.querySelector("#" + cityName);
  currentTab.style.display = "block";
  evt.currentTarget.className += " active";
}

const dialog = document.getElementById("sampleDialog");
const openButton = document.getElementById("openDialog");
const closeButton = document.getElementById("closeDialog");
const overlay = document.querySelector('.size-guide-overlay');



// Event listener to open the dialog
openButton.addEventListener("click", function () {
  dialog.style.display = "block";
  overlay.style.opacity = '1';
});

// Event listener to close the dialog
closeButton.addEventListener("click", function () {
  dialog.style.display = "none";
  overlay.style.opacity = '0';
});
